import { render } from "./DetallesLead.vue?vue&type=template&id=2f88f7cf&scoped=true"
import script from "./DetallesLead.vue?vue&type=script&lang=js"
export * from "./DetallesLead.vue?vue&type=script&lang=js"

import "./DetallesLead.vue?vue&type=style&index=0&id=2f88f7cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f88f7cf"]])

export default __exports__